<template>
    <div class="select-outer select-outer--search">
        <input type="text"
               v-model="selected"
               @keyup="debounce(selected, $event)"
               @keydown="keydownEvent($event)">
        <ul v-show="isOpened()"
            @mouseleave="closeDropdown()">
            <li v-for="(user, index) in getList()"
                :class="{ 'active' : userHovered === index }"
                @mouseover="userHover(index)"
                @click="onElementClick(user), selectUser(user.login), closeDropdown()">
                {{ user.login }}
            </li>
        </ul>
    </div>
</template>
<script>
    export default {
        props: ['autocomplete', 'searchUrl', 'onElementClick'],
        data () {
            return {
                selected: '',
                index: 0,
                sending: false,
                list: [],
                opened: false,
                searchDebounce: null,
                userHovered: null
            }
        },
        methods: {
            debounce (value, event) {
                // Do not nothing if Tab key pressed
                if(event && event.key === 'Tab' || event.key === 'Enter') {
                    return;
                }

                // Own debounce implementations because debounce VUE is deprecated
                // See https://github.com/vuejs/vue/issues/2873
                if(this.searchDebounce) {
                    clearTimeout(this.searchDebounce);
                }
                this.searchDebounce = setTimeout(() => this.search(value), 400);
            },
            search(value) {
                // Do not call API when empty
                if(!value) {
                    return;
                }

                this.$http.get(this.searchUrl(value))
                    .then((results) => {
                        this.list = results.data.data;
                        this.openDropdown();
                        this.selectFirst();
                    })
            },
            keydownEvent(event) {
                // Do not lost focus when tab key used
                if(event.key === 'Tab') {
                    this.selectNext();
                    event.preventDefault();
                }

                // Autocomplete when press enter
                if(event.key === 'Enter') {
                    let newSelection = this.selected = this.list[this.userHovered].login;
                    this.onElementClick(newSelection);
                    this.closeDropdown();
                }
            },
            userHover (index) {
                this.userHovered = index;
            },
            selectNext () {
                let len = this.list.length;

                if (len <= this.userHovered + 1) {
                    this.userHovered = 0;
                    this.userHover(0);
                } else {
                    this.userHovered++;
                }
            },
            selectFirst () {
                this.userHovered = 0;
            },
            selectUser (user) {
                this.selected = user;
            },
            isOpened() {
                return this.opened
            },
            openDropdown() {
                this.opened = true;
            },
            closeDropdown() {
                this.opened = false;
            },
            getList() {
                return this.list;
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import '../../../assets/scss/_colors.scss';

    .select-outer {
        ul {
            z-index: 11;
            li {
                &.active,
                &.active:hover {
                    background: $base1;
                    color: $white;
                }
                &:hover {
                    background: transparent;
                    color: $black;
                }

            }
        }
        &:after {
            font: normal normal normal 24px/1 "Material Design Icons";
            content: "\F349";
            border: none;
            top: 9px;
            right: 27px;
            color: $base1;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/shared/dropdown/Dropdown.component.vue